import React, { useContext, useEffect, useState } from "react";
import "./New.scss";
import HomeIcon from "./assets/new_imgs/Group 38660.png";
import SearshIcon from "./assets/new_imgs/Path 445.png";
import CartIcon from "./assets/new_imgs/Path 444.png";
import WhatsappIcon from "./assets/new_imgs/Group 38659.png";
import MenuIcon from "./assets/new_imgs/Group 38658.png";
import { Link, useLocation, useParams } from "react-router-dom";
import axios from "./axios";
import { ShowCheckout } from "./API/CheckoutAPI";
import { ThemeContext } from "./context/ThemeContext";
import Currency from "./Components/Currency";

const NewFooter = () => {
  const location = useLocation();
  const { setTheme } = useContext(ThemeContext);
  const room_qr = localStorage.getItem("room_uuid_before_redirect");
  const lang = localStorage.getItem("lang");
  const region = process.env.REACT_APP_SERVER_REGION;
  const [roomNumber, setRoomNumber] = useState();
  const [useSMS, setUseSMS] = useState(false);
  const [guestName, setGuestName] = useState("");

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  let flattenedArray;
  let cart_count = 0;
  let check;

  if (room_uuid) {
    const { data, isLoading, error } = ShowCheckout(room_uuid);

    if (!isLoading) {
      check = data?.data?.data;

      const tempItems = check?.order?.map((order) => {
        return order?.items.map((aa) => aa);
      });
      const combo_meal = check?.order[0]?.combo_meals?.length || 0;
      if (tempItems) {
        flattenedArray = [].concat(...tempItems);
        cart_count =
          flattenedArray?.length == 0
            ? 0
            : flattenedArray
                ?.map((item) => item?.quantity)
                .reduce((acc, curr) => (acc += curr));
        cart_count = cart_count + combo_meal;
      }
    }
  }
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [isWhatsapp, setIsWhatsapp] = useState(false);

  useEffect(() => {
    const getData = () => {
      axios.get(`/${room_uuid}/qr-code?source=footer`).then((res) => {
        const data = res.data.data;
        setUseSMS(data?.use_sms);
        setRoomNumber(data?.room_number);
        // localStorage.setItem("is_meeting_room", data?.is_meeting_room);
        localStorage.setItem("room_number", data?.room_number);
        localStorage.setItem("currency", data?.currency || "AED");
        localStorage.setItem("color", data?.color);
        localStorage.setItem("active_flexipass", data?.active_flexipass);
        localStorage.setItem("new_design", data?.use_new_design);
        setTheme(data?.use_new_design);

        setIsWhatsapp(data?.whatsapp_enabled);
        setWhatsappNumber(data?.whatsapp_number);
        localStorage.setItem("tax_inclusive", data?.tax_inclusive);
        localStorage.setItem("show_prices", data?.show_prices);
        localStorage.setItem("has_extra_services", data?.has_extra_services);
        localStorage.setItem("room_number", data?.room_number);
        localStorage.setItem("businessType", data.businessType);
        localStorage.setItem("countryCode", data?.country_code || "ae");
        localStorage.setItem("welcome_message", data?.welcome_message);
        localStorage.setItem("business_id", data?.business_id);
        localStorage.setItem("room_type", data?.room_type);

        const sessionInfo = {
          "Room UUID": room_qr,
          "Session ID": room_uuid,
          "Business Name": data?.business_name,
          "Room Number": data?.room_number,
          "Location Type": data?.room_type,
          "Business ID": data?.business_id,
          "Server Region": region,
          Language: lang,
          Platform: "Web",
          utm_source: "",
          utm_medium: "",
          utm_campaign: "",

          // OS: navigator.platform,
        };
        localStorage.setItem("mixpannel_data", JSON.stringify(sessionInfo));

        // setIsWhatsapp(data?.whatsapp_enabled);
        // setWhatsappNumber(data?.whatsapp_number);
        // color = data?.color
        // setColor(data?.color);
        if (data?.color) {
          document.documentElement.style.setProperty("--color", data?.color);
          document.documentElement.style.setProperty(
            "--color_t",
            `${data?.color}b3`,
          );

          document.documentElement.style.setProperty(
            "--header_color",
            data?.header_color,
          );
        }
      });
    };
    getData();
  }, []);
  const params = useParams();
  const message = `Hello, I need assistance for my room ${roomNumber}.`;

  const contactHref = useSMS
    ? `sms:${whatsappNumber}?body=${encodeURIComponent(message)}`
    : `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
        message,
      )}`;
  return (
    <div className="new_footer">
      <ul>
        <li>
          <Link to={`/${params.room_uuid}/menu`}>
            <img src={MenuIcon} alt="" />
          </Link>
        </li>
        <li>
          <Link to={`/${params.room_uuid}/search`}>
            <img src={SearshIcon} alt="" />
          </Link>
        </li>
        <li>
          <Link to={`/${params.room_uuid}/qr-code`}>
            <img src={HomeIcon} alt="" />
          </Link>
        </li>
        <li>
          <Link to={`/${params.room_uuid}/cart`}>
            <img src={CartIcon} alt="" />
            <span>{cart_count}</span>
          </Link>
        </li>
        {isWhatsapp && (
          <li>
            <a href={contactHref}>
              <img src={WhatsappIcon} alt="" />
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};

export default NewFooter;
